enum AccessibilityAppColorEnum
{
	"app-color-vert" = "Vert (défaut)",
	"app-color-rouge" = "Rouge",
	"app-color-orange" = "Orange",
	"app-color-jaune" = "Jaune",
	"app-color-bleu" = "Bleu",
	"app-color-violet" = "Violet",
	"app-color-magenta" = "Magenta",
	"app-color-marron" = "Marron",
	"app-color-gris" = "Gris"
}

export default AccessibilityAppColorEnum;
